<template>
  <div class="wuxing-login">
    <div class="login">
      <div class="title">裁判员登录</div>
      <div class="login-area">
        <m-input v-model="phone" placeholder="请输入用户名" clearable />
        <m-input class="code" type="password" v-model="password" placeholder="输入密码" clearable />
        <van-button class="login-btn" round block @click="submit">登 录</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import MInput from 'components/wuxing/MInput.vue'
import { judgeLogin } from '../../libs/api.js'

export default {
  components: { MInput },
  data() {
    return {
      phone: '',
      password: '',
    }
  },
  methods: {
    submit() {
      if (!this.phone) {
        this.$notify({ type: 'warning', message: '用户名不能为空' })
        return
      } else if (!this.password) {
        this.$notify({ type: 'warning', message: '密码不能为空' })
        return
      }
      judgeLogin({
        phone: this.phone,
        password: this.password,
      }).then((r) => {
        if (Number(r.status) === 200) {
          this.judge_info = r.data
          localStorage.setItem('judge_info', JSON.stringify(r.data))
          this.$router.push({ name: 'wuxing_judge', query: this.$route.query })
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
.login {
  background: url(../../assets/BG2.png) no-repeat center center/cover;
  height: 100vh;
  width: 100%;
  padding: 0 30px;
  box-sizing: border-box;
  .title {
    font-size: 30px;
    text-align: center;
    color: #fff;
    padding-top: 140px;
  }
  .login-area {
    margin-top: 40px;
    background: #ffffff;
    box-shadow: 0 5px 10px 0 rgba(0, 102, 232, 0.75);
    border-radius: 20px;
    padding: 30px 15px 40px;
    .code {
      margin-top: 16px;
    }
    .m-input {
      border-radius: 28px;
    }
    .code-btn {
      padding: 0px 6px;
      box-shadow: 0 2px 6px 0 #d5e2ef;
      border-radius: 29px;
      height: 24px;
      line-height: 24px;
      color: #82a6d5;
    }
    .login-btn {
      margin-top: 32px;
      background: #47a3fb;
      color: #fff;
    }
  }
}
</style>
